import { Component, OnInit, Input, ContentChild, Inject } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';
import { BaseModuleComponent } from '~Interfaces/basemodulecomponent';

import { ParametrageApplicatifService } from '~Services/parametrage-applicatif.service';

/**
 * Composant de module fiche relais
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-fiche-relais-module',
  templateUrl: './fiche-relais-module.component.html',
  styleUrls: ['./fiche-relais-module.component.scss']
})
export class FicheRelaisModuleComponent extends BaseComponent implements OnInit {

    @Input() titre: string;
    @Input() sousTitre: string;
    @Input() description: string;

    @ContentChild(BaseModuleComponent, { static: true }) component: BaseModuleComponent;

    actif: boolean = true;

    /**
     * Constructeur
     */
    constructor(@Inject(ParametrageApplicatifService) private parametrageApplicatifService: ParametrageApplicatifService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Initialisation du contenu
     */
    ngAfterContentInit() {
        // Initialiser le module
        this.initModule();
    }

    /**
     * Lister les modules inactifs
     */
    private listerModulesInactifs(): string[] {
        let resultat = [];
        // Obtenir les modules inactifs depuis le paramétrage applicatif (JSON)
        let json = this.parametrageApplicatifService.obtenir('modules.inactifs');
        if (json) {
            try {
                // Récupère la liste des modules inactifs depuis le JSON
                let modules = JSON.parse(json);
                resultat = Array.isArray(modules) ? modules : [];
            }
            catch {}
        }
        return resultat;
    }

    /**
     * Indique si le module est actif
     */
    private moduleEstActif(): boolean {
        let modulesInactifs = this.listerModulesInactifs();
        return this.component ? modulesInactifs.indexOf(this.component.componentName) == -1 : true;
    }

    /**
     * Lister les modules readonly
     */
    private listerModulesLectureSeule(): string[] {
        let resultat = [];
        // Obtenir les modules en lecture seule depuis le paramétrage applicatif (JSON)
        let json = this.parametrageApplicatifService.obtenir('modules.lecture-seul');
        if (json) {
            try {
                // Récupère la liste des modules lecture seule depuis le JSON
                let modules = JSON.parse(json);
                resultat = Array.isArray(modules) ? modules : [];
            }
            catch { }
        }
        return resultat;
    }

    /**
     * Indique si le module est en lecture seule
     */
    private moduleEstLectureSeule(): boolean {
        let modulesReadonly = this.listerModulesLectureSeule();
        return this.component ? modulesReadonly.indexOf(this.component.componentName) != -1 : true;
    }

    /**
     * Initialiser le module
     */
    private initModule() {
        // Vérifier si le module est actif
        if (this.actif = this.moduleEstActif()) {
            // Lecture seule ?
            if (this.moduleEstLectureSeule()) {
                this.component.readonly = true;
            }
            // Initialiser le module
            this.component.Init();
        }
    }
}
